import { render, staticRenderFns } from "./QuickLink.vue?vue&type=template&id=ffc2d010&"
import script from "./QuickLink.vue?vue&type=script&lang=js&"
export * from "./QuickLink.vue?vue&type=script&lang=js&"
import style0 from "./QuickLink.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports